<template>
    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addEditSupplierOrder :procurementId="procurementId"></addEditSupplierOrder>
    </v-dialog>
</template>

<script>
    import addEditSupplierOrder from '../Shared/AddSupplierOrder.vue'

    // Settings Types
    import {
        SupplierOrder
    } from '../../store/namespace-helper'

    export default {
      name: 'supplier-order-dialog',
      components: {
        addEditSupplierOrder
      },
      props: {
        procurementId: {
          type: Number,
          default: 0
        }
      },
      data () {
        return {}
      },
      methods: {},
      computed: {
        dialog () {
          return this.$store.getters[SupplierOrder.getters.getOpenDialogState]
        }
      }
/*
      beforeMount () {
        this.$emit('mounting', true)
      },
      mounted () {
        this.$emit('mounting', false)
      },
      updated () {
        if (!this.dialog) {
          this.$nextTick(() => {
            this.$emit('closing', false)
          })
        }
      },
      beforeDestroy () {

      }
      */
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/SupplierOrders/AddSupplierOrderDialog.vue